import React from "react";
import PolicyPage from "./PolicyScreen";

export default function TermsOfServicePage() {
  return <PolicyPage kind="terms" />;
}
